import { GridService } from "../shared/grid/grid.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CalibrationEquipment } from "../models/calibrationEquipment.model";
import { Observable } from "rxjs";
import { CalibrationStatusSummaryResponse } from "../models/calibration-status-summary.model";
import nameOf from "../shared/form/nameOf.helper";

@Injectable({
    providedIn: "root",
})
export class CalibrationEquipmentService extends GridService<CalibrationEquipment> {
    constructor(http: HttpClient) {
        super("CalibrationEquipment", http);
    }

    getCalibrationStatusSummary(
        organizationLevelId?: string,
    ): Observable<CalibrationStatusSummaryResponse> {
        let params = new HttpParams();
        if (organizationLevelId != null) {
            params = params.set(
                nameOf<CalibrationEquipment>((x) => x.organizationLevelId),
                organizationLevelId,
            );
        }
        return this.http.get<CalibrationStatusSummaryResponse>(
            this.getApiUrl(
                `${this.controllerName}/GetCalibrationStatusSummary`,
            ),
            { params },
        );
    }
}
